import React from "react";
import { TabsProps } from "../types";

export const TabsContext = React.createContext<TabsProps>({});
